import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CalendarAPI } from '../../api/CalendarAPI';
import { rootAction } from '../../redux/reducer/rootReducer';
import { AuthContext } from '../auth/AuthContext';
import { Tooltip } from '@mui/material';
import { PaymentAPI } from '../../api/PaymentAPI';

const Timer = () => {
    const { setMessage } = useContext(AuthContext);
    const { initialTimer, isTimerActive, disablePayBtn, paymentIntentId } = useSelector((store) => store.root);
    const { userInfo, clubId } = useSelector((store) => store.user);
    const [percentage, setPercentage] = useState(0);
    const [timeLeft, setTimeLeft] = useState(0);
    const dispatch = useDispatch();
    let minutes = 0;
    let seconds = 0;
    const deleteReservation = async () => {
       
        try {
            await CalendarAPI.deleteReservationWhenNotPaid({ userId: userInfo?.userId, clubId: clubId });
            dispatch(rootAction.setReservationPaymentStatus(({ status: true, type: 'deleted' })));
        } catch (error) {

        }
    }
   
    useEffect(() => {
        if (initialTimer) {
            setTimeLeft(initialTimer)
        }
    }, [initialTimer, isTimerActive])
    useEffect(() => {
        let timer;
        if (initialTimer && isTimerActive) {
            timer = setInterval(() => {
                setTimeLeft((prevTime) => {
                    const newTimeLeft = prevTime - 1;
                    if (newTimeLeft < 30) {
                    if(!disablePayBtn){
                        dispatch(rootAction.setDisablePayBtn(true));
                    }
                    }
                    if (newTimeLeft < 0) {
                        // cancelPaymentIntent();
                        clearInterval(timer);
                        setPercentage(-1);
                        setMessage({ type: 'info', content: 'A timeout has been reached. We have canceled the reservation.' });
                        setTimeout(() => {
                            setMessage({ type: '', content: '' });
                        }, 4000);
                        dispatch(rootAction.setDisablePayBtn(false));
                        dispatch(rootAction.setIsTimerActive(false));
                        deleteReservation();
                        return 0;
                    }
                    setPercentage(Math.floor((newTimeLeft / 300) * 100));
                    return newTimeLeft;
                });
            }, 1000);
        } else {
            setPercentage(-1);
        }
        return () => clearInterval(timer);
    }, [initialTimer, isTimerActive]);
    if (timeLeft >= 0) {
        minutes = Math.floor(timeLeft / 60);
        seconds = timeLeft % 60;
        const waterRedElement = document.querySelector(".sm_res_timer_red .sm_res_timer_progress .sm_res_timer_inner .sm_res_timer_water");
        const waterOrangeElement = document.querySelector(".sm_res_timer_orange .sm_res_timer_progress .sm_res_timer_inner .sm_res_timer_water");
        const waterGreenElement = document.querySelector(".sm_res_timer_green .sm_res_timer_progress .sm_res_timer_inner .sm_res_timer_water");
        let progressBar = 100 - Number(percentage);
        if (waterRedElement) {
            waterRedElement.style.top = progressBar.toString() + '%';
        }
        if (waterGreenElement) {
            waterGreenElement.style.top = progressBar.toString() + '%';
        }
        if (waterOrangeElement) {
            waterOrangeElement.style.top = progressBar.toString() + '%';
        }
    }

    return (
        <div className='sm_res_timer_container'>
            <Tooltip
                style={{ position: 'absolute', top: '-8px' }}
                title="Please complete transaction before timeout">
                <div className="sm_res_timer_wrapper">
                    {percentage >= 70 &&
                        <div className="sm_res_timer_green">
                            <div className="sm_res_timer_progress">
                                <div className="sm_res_timer_inner">
                                    <div className="sm_res_timer_percent"> <span>{minutes?.toString().padStart(2, '0')}:{seconds?.toString().padStart(2, '0')}</span></div>
                                    <div className="sm_res_timer_water"></div>
                                    <div className="sm_res_timer_glare"></div>
                                </div>
                            </div>
                        </div>}
                    {(percentage >= 30 && percentage < 70) &&
                        <div className="sm_res_timer_orange">
                            <div className="sm_res_timer_progress">
                                <div className="sm_res_timer_inner">
                                    <div className="sm_res_timer_percent"> <span>{minutes?.toString().padStart(2, '0')}:{seconds?.toString().padStart(2, '0')}</span></div>
                                    <div className="sm_res_timer_water"></div>
                                    <div className="sm_res_timer_glare"></div>
                                </div>
                            </div>
                        </div>}
                    {(percentage >= 0 && percentage < 30) &&
                        <div className="sm_res_timer_red">
                            <div className="sm_res_timer_progress">
                                <div className="sm_res_timer_inner">
                                    <div className="sm_res_timer_percent"> <span>{minutes?.toString().padStart(2, '0')}:{seconds?.toString().padStart(2, '0')}</span></div>
                                    <div className="sm_res_timer_water"></div>
                                    <div className="sm_res_timer_glare"></div>
                                </div>
                            </div>
                        </div>}
                </div>
            </Tooltip>
        </div>
    )
}

export default Timer